import { render, staticRenderFns } from "./shortcodeTeam.vue?vue&type=template&id=a25c621e&"
import script from "./shortcodeTeam.vue?vue&type=script&lang=js&"
export * from "./shortcodeTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports